import { render, staticRenderFns } from "./gift-card-list.vue?vue&type=template&id=0f445014&scoped=true&lang=html&"
import script from "./gift-card-list.vue?vue&type=script&lang=js&"
export * from "./gift-card-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f445014",
  null
  
)

export default component.exports